import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { status } from 'constants/general';
import postsStrings from 'modules/posts/strings';
import RssFeedHeader from 'modules/posts/components/RssFeedHeader';
import RssFeedFilter from 'modules/posts/components/RssFeedFilter';
import RssFeedList from 'modules/posts/components/RssFeedList';
import Loader from 'modules/common/components/Loader';
import Popup from 'modules/common/components/Popup';

import {
  RssFeedWrapper,
  LoaderWrapper,
  NoResultsWrapper,
  NoResultsText,
  ImgPreview,
  VideoPreview,
  VideoPreviewSrc,
  ToastTextOverlay,
} from './RssFeedComponent.style';

const RssFeedComponent = ({
  showCopiedTextOverlay,
  searchQuery,
  isPreviewFilePopupOpen,
  previewFileData,
  isActionPopupOpen,
  isActionPopupLoading,
  actionPopupStatus,
  handleTextToCopyToClipboardClick,
  handleAddRssFeedBtnClick,
  handleSearchBarInputChange,
  handlePreviewFileClick,
  handleActionBtnClick,
  handleActionPopupConfirmBtnClick,
  handleActionPopupDismissBtnClick,
}) => {
  const { staticData, companyProfilesList, rssFeedList } = useSelector(state => ({
    staticData: state.common.staticData,
    companyProfilesList: state.common.companyProfilesList,
    rssFeedList: state.posts.rssFeedList,
  }));

  const rssFeedListArr = rssFeedList?.details?.data;

  const renderRssFeedList = () => {
    if (
      rssFeedList.status === status.SHOULD_CALL_API ||
      rssFeedList.status === status.FETCHING ||
      staticData.status === status.SHOULD_CALL_API ||
      staticData.status === status.FETCHING ||
      companyProfilesList.status === status.SHOULD_CALL_API ||
      companyProfilesList.status === status.FETCHING
    )
      return (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      );

    if (
      (rssFeedList.status === status.SUCCESS && rssFeedListArr?.length === 0) ||
      rssFeedList.status === status.FAIL
    )
      return (
        <NoResultsWrapper>
          <NoResultsText>{postsStrings.rssFeedList.rssFeedGridNoResultsFound}</NoResultsText>
        </NoResultsWrapper>
      );

    return (
      <>
        <RssFeedList
          rssFeedListArr={rssFeedListArr}
          isActionPopupOpen={isActionPopupOpen}
          isActionPopupLoading={isActionPopupLoading}
          actionPopupStatus={actionPopupStatus}
          handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
          handlePreviewFileClick={handlePreviewFileClick}
          handleActionBtnClick={handleActionBtnClick}
          handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
          handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
        />
        {isPreviewFilePopupOpen && (
          <Popup handleCloseBtnClick={() => handlePreviewFileClick(false)}>
            {(previewFileData.type === 'image' && <ImgPreview src={previewFileData.url} />) || (
              <VideoPreview controls>
                <VideoPreviewSrc src={previewFileData.url} />
              </VideoPreview>
            )}
          </Popup>
        )}
        {showCopiedTextOverlay && (
          <ToastTextOverlay>{postsStrings.rssFeedList.copiedToClipboardText}</ToastTextOverlay>
        )}
      </>
    );
  };

  return (
    <>
      <RssFeedHeader handleAddRssFeedBtnClick={handleAddRssFeedBtnClick} />
      <RssFeedWrapper id="posts-wrapper">
        <RssFeedFilter
          searchQuery={searchQuery}
          handleSearchBarInputChange={handleSearchBarInputChange}
        />
        {renderRssFeedList()}
      </RssFeedWrapper>
    </>
  );
};

RssFeedComponent.propTypes = {
  showCopiedTextOverlay: PropTypes.bool.isRequired,
  searchQuery: PropTypes.string.isRequired,
  isPreviewFilePopupOpen: PropTypes.bool.isRequired,
  previewFileData: PropTypes.shape({
    type: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  isActionPopupOpen: PropTypes.bool.isRequired,
  isActionPopupLoading: PropTypes.bool.isRequired,
  actionPopupStatus: PropTypes.shape({}).isRequired,
  handleTextToCopyToClipboardClick: PropTypes.func.isRequired,
  handleAddRssFeedBtnClick: PropTypes.func.isRequired,
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handlePreviewFileClick: PropTypes.func.isRequired,
  handleActionBtnClick: PropTypes.func.isRequired,
  handleActionPopupConfirmBtnClick: PropTypes.func.isRequired,
  handleActionPopupDismissBtnClick: PropTypes.func.isRequired,
};

export default RssFeedComponent;
